/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_Examples_DescInputs */

const es_prompt_tips_examples_desc = /** @type {(inputs: Prompt_Tips_Examples_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si esperás un formato particular o un tipo de dato específico, incluí un ejemplo de cómo te gustaría ver la respuesta.`)
};

const en_prompt_tips_examples_desc = /** @type {(inputs: Prompt_Tips_Examples_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you expect a particular format or specific type of data, include an example of how you'd like to see the response.`)
};

/**
* | output |
* | --- |
* | "If you expect a particular format or specific type of data, include an example of how you'd like to see the response." |
*
* @param {Prompt_Tips_Examples_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_examples_desc = /** @type {((inputs?: Prompt_Tips_Examples_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_Examples_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_examples_desc(inputs)
	return en_prompt_tips_examples_desc(inputs)
});
export { prompt_tips_examples_desc as "prompt_tips.examples_desc" }